<template>
  <div class="p-3" id="customer-info">

    <el-dialog append-to-body :visible.sync="configNoteVisible" width="700px">
      <NoteConfig />
    </el-dialog>


    <div v-for="(item,ind) in data" :key="ind">
      <div class="mt-1 font-size-14 fw-semibold"> {{ item.title }}</div>
      <el-input v-model="item.value" class="mt-1" />
    </div>
    <div class="d-flex justify-content-end mt-2">
      <el-button icon="el-icon-setting" size="small" @click="configNote()">Thiết lập</el-button>
      <el-button type="primary" icon="el-icon-folder" size="small" @click="save">Lưu</el-button>

    </div>
  </div>

</template>
<script>
import NoteConfig from "@/components/NoteConfig";

export default {
  components: { NoteConfig },
  props: ["conversation"],
  watch: {
    conversation: function() {
      this.getInfo();
    }
  },
  data() {
    return {
      historyNoteVisible: false,
      configNoteVisible: false,
      data: []
    };
  },
  methods: {
    configNote() {
      this.configNoteVisible = true;
    },
    getInfo() {
      this.data = [];
      this.$http.get("/api/v2/customer/getInfo", {
        params: {
          accountId: this.conversation.accountId,
          toId: this.conversation.toId,
          conversationId: this.conversation.id
        }
      })
        .then(resp => {
          let dt = resp.data;
          this.app.customerCodeList.forEach(b => {
            if (!b.hidden) {
              let p = {
                index: b.index,
                title: b.title,
                value: null,
                cid: 0,
                conversationId: this.conversation.id,
                id: b.id
              };
              let f = dt.find(t => t.code == b.id);
              if (f) {
                p.value = f.value;
                p.cid = f.id;
              }
              this.data.push(p);
            }
          });
          this.data.sort((a, b) => a.index - b.index);
          console.log(this.data);
        });
    },
    save() {
      this.$http.post("/api/v2/customer/save", { "info": this.data })
        .then(() => {
          this.alert("success", "Cập nhật thành công.");
        })
        .catch((ex) => {
          this.alert("error", ex.error ? ex.error.message : "Có lỗi xảy ra.");
        });
    }

  },
  created() {
    this.getInfo();
    this.$bus.$on("closeNoteConfig", () => {
      this.configNoteVisible = false;
      this.getInfo();
    });
  }
};
</script>
<style scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
